import React from 'react'
import { withRouter } from 'react-router-dom'

const UnprotectedShell: React.FC = (props: any) => {
  return <React.Fragment>{props.children}</React.Fragment>
}

export default withRouter(UnprotectedShell)
